import React from 'react';
import { useDispatch } from 'react-redux';
import { clearUser } from '../feature/user.Slice'; 

/**
 * Logout est un composant qui permet à l'utilisateur de se déconnecter.
 * Il utilise le hook useDispatch de 'react-redux' pour dispatcher l'action clearUser.
 * Lorsque l'utilisateur clique sur le bouton 'Se déconnecter', l'action clearUser est dispatchée,
 * ce qui efface les informations de l'utilisateur du store Redux.
 *
 */

const Logout = () => {
    const dispatch = useDispatch();

    const handleLogout = () => {
        // Dispatch l'action clearUser
        dispatch(clearUser());
    };

    return (
        <button 
            className="bg-theme-accent text-white px-4 py-2 rounded-lg font-semibold hover:bg-theme-accent-active transition-all duration-300 hover:shadow-lg hover:-translate-y-1 active:translate-y-0 active:shadow-md"
            onClick={handleLogout}
        >
            Se déconnecter
        </button>
    );
};

export default Logout;